import { Collapse, Tag } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

export const SelectAllWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  font-weight: 500;
`;

export const EmptyActivities = styled.div`
  color: ${({ theme }) => theme.colors.black5};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

const getBorderRadius = (value: boolean) => (value ? '4px' : '0');

export const StyledCollapse = styled(Collapse)<{ $isFirst: boolean; $isLast: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: ${({ $isLast }) => ($isLast ? undefined : 'none')};
  border-top-left-radius: ${({ $isFirst }) => getBorderRadius($isFirst)};
  border-top-right-radius: ${({ $isFirst }) => getBorderRadius($isFirst)};
  border-bottom-left-radius: ${({ $isLast }) => getBorderRadius($isLast)};
  border-bottom-right-radius: ${({ $isLast }) => getBorderRadius($isLast)};

  .ant-collapse-item > .ant-collapse-header {
    padding: 9px 16px;
    align-items: center;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 8px 48px;
    background-color: ${({ theme }) => theme.colors.black1};
    color: ${({ theme }) => theme.colors.black7};
  }
`;

export const StyledTag = styled(Tag)`
  max-height: 22px;
`;
